import React from 'react';

function Receipt({ customerDetails, paymentDetails }) {
    return (
      <>
        <div className="row">
          <div className="col-md-6">
            <div className="coustomer-detail">
              <h3 className='mb-3'>Customer Details:</h3>
              <ul>
                <li><strong>Name:</strong> <span className="gray-clr">{customerDetails.name}</span></li>
                <li><strong>Email:</strong> <span className="gray-clr">{customerDetails.email}</span></li>
                <li><strong>Phone:</strong> <span className="gray-clr">{customerDetails.phone}</span></li>
                <li><strong>Booking Date:</strong> <span className="gray-clr">{customerDetails.bookingDate}</span></li>
                <li><strong>Unit:</strong> <span className="gray-clr">{customerDetails.unit}</span></li>
                <li><strong>Shift:</strong> <span className="gray-clr">{customerDetails.shift}</span></li>
              </ul>
            </div>
          </div>
          <div className="col-md-6">
            <div className="payment-detail">
              <h3 className='mb-3'>Payment Details:</h3>
              <ul>
                <li><strong>Before Discount:</strong> <span className="gray-clr">{paymentDetails.beforeDiscount}</span></li>
                <li><strong>Discount:</strong> <span className="gray-clr">{paymentDetails.discount}</span></li>
                <li><strong>Total Amount after Discount:</strong> <span className="gray-clr">{paymentDetails.totalAmount}</span></li>
                <li><strong>Paid Amount:</strong> <span className="gray-clr">{paymentDetails.paidAmount}</span></li>
                <li><strong>Remaining Amount:</strong> <span className="gray-clr">{paymentDetails.remainingAmount}</span></li>
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  }

export default Receipt;
